<template>
  <b-modal
    id="quiz-v2"
    ref="modal"
    centered
    hide-footer
    hide-header
    size="md"
    @hidden="onHidden"
  >
    <b-overlay :show="loading">
      <b-container fluid class="p-4" v-if="question">
        <div class="d-flex align-items-center justify-content-between">
          <h3 class="text-primary">{{ $t('dashboard.quiz') }}!</h3>
          <p @click="close()" style="cursor:pointer; color:#D4D4D4">
            {{ answered ? $t('close') : $t('skip') }}
          </p>
        </div>

        <div class="mt-4">
          <b-row>
            <b-col cols="12" class="mb-3">
              <p class="text-primary font-weight-bold">{{ question.question }}</p>
            </b-col>
          </b-row>

          <div v-if="!answered">
            <b-form @submit.prevent="submit">
              <b-form-group>
                <b-form-radio-group v-model="selected" stacked>
                <b-form-radio
                    v-for="a in (question.answers || [])"
                    :key="a.quiz_answer_id"
                    :value="a.quiz_answer_id"
                    style="margin-bottom:14px; font-size:15px; color:#545454;"
                >
                    {{ a.answer }}
                </b-form-radio>
                </b-form-radio-group>
              </b-form-group>

              <b-button block variant="primary" type="submit" :disabled="!selected || submitting">
                <span v-if="!submitting">{{ $t('dashboard.submit_answer') }}</span>
                <span v-else><b-spinner small></b-spinner></span>
              </b-button>
            </b-form>
          </div>

          <div v-else class="mt-3">
            <div v-if="result.isCorrect">
              <p class="text-primary text-center font-weight-medium mb-2">
                {{ $t('dashboard.correct_answer') }}
              </p>
              <p class="text-primary text-center">
                {{ $t('dashboard.You earned') }} {{ result.earnedPoints }} {{ $t('points') }}
              </p>
            </div>
            <div v-else>
              <p class="text-primary text-center font-weight-medium mb-2">
                {{ $t('dashboard.wrong_answer') }}
              </p>
              <p class="text-primary text-center mb-2">
                {{ $t('dashboard.correct_answer_is') }}: {{ result.correctAnswerText }}
              </p>
              <p class="text-primary text-center">
                {{ $t('dashboard.better_luck') }}
              </p>
            </div>
          </div>
        </div>
      </b-container>
    </b-overlay>
  </b-modal>
</template>

<script>
import axios from "axios"

export default {
  name: "QuizModalV2",
  props: {
    // keep prop name for easy swap with old modal
    quiz_id: { type: [Number, String], default: null }
  },
  data() {
    return {
      loading: false,
      submitting: false,
      selected: null,
      question: null,
      answered: false,
      result: null,
      currentQuizId: null
    }
  },
  watch: {
    // open whenever parent sets quiz_id
    async quiz_id(id) {
      if (!id) return
      await this.fetchQuiz(id)
      this.$refs.modal.show()
    }
  },
  methods: {
    async fetchQuiz(quizId) {
      this.currentQuizId = quizId
      this.loading = true
      this.submitting = false
      this.answered = false
      this.result = null
      this.selected = null
      try {
        const { data } = await axios.get("/gameboard/quizquestion", { params: { quiz_id: quizId } })
        this.question = (data && data.data && data.data[0]) ? data.data[0] : null
      } finally {
        this.loading = false
      }
    },
    async submit() {
      if (!this.selected) return
      this.submitting = true
      try {
        const { data } = await axios.post("/gameboard/quizquestion", { quiz_answer_id: this.selected })
        const r = (data && data.data) ? data.data : {}
        this.result = {
          isCorrect: r.correct_answer_flg === "Y",
          earnedPoints: Number(r.earned_points || 0),
          correctAnswerText: r.correct_answer || ""
        }
        this.answered = true

        // notify parent so icon updates instantly
        this.$emit('answered', { quizId: this.currentQuizId, result: this.result })
      } catch (err) {
        const status = err && err.response && err.response.status
        const payload = err && err.response && err.response.data

        // backend says: 409 + answered:true
        const alreadyAnswered = status === 409 && payload && payload.answered === true

        if (alreadyAnswered) {
          this.answered = true
          this.$emit('answered', { quizId: this.currentQuizId, alreadyAnswered: true })
          // optional: you can close immediately if you prefer:
          // this.close()
          return
        }

        // otherwise rethrow or handle with a toast/snackbar if you have one
        throw err
      } finally {
        this.submitting = false
      }
    },
    close() {
      this.$refs.modal.hide()
    },
    onHidden() {
      this.$emit("close-modal")
    }
  }
}
</script>

<style scoped>

/* Unchecked radio circle */
.custom-radio .custom-control-label::before {
  border: 2px solid #1a1947 !important;  /* dark border */
  background-color: #1a1947 !important;
  box-shadow: none !important;
  width: 1.2rem;
  height: 1.2rem;
}

/* Checked radio circle */
.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #1a1947 !important;
  background-color: #E63375 !important; /* primary */
}

div >>> #quiz-v2___BV_modal_content_ { border-radius: 15px; border: none; }


</style>
